import script from "./WelcomeInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./WelcomeInfo.vue?vue&type=script&setup=true&lang=ts"

import "./WelcomeInfo.vue?vue&type=style&index=0&id=2e17d866&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e17d866"]])

export default __exports__